// types
import { FeatureFlag } from '../@types';

export function isFeatureEnabled(feature: FeatureFlag): boolean {
	return process.env[`REACT_APP_${feature}`] === 'true';
}

export const featureFlags: Record<FeatureFlag, boolean> = {
	ACTIVITIES: isFeatureEnabled('ACTIVITIES'),
	CRM: isFeatureEnabled('CRM'),
	DIRECT: isFeatureEnabled('DIRECT'),
	FINANCIAL_TRACEABILITY: isFeatureEnabled('FINANCIAL_TRACEABILITY'),
	IFRS: isFeatureEnabled('IFRS'),
	LEARNING_HUB: isFeatureEnabled('LEARNING_HUB'),
	LOCAL_CURRENCY: isFeatureEnabled('LOCAL_CURRENCY'),
	PREREQUISITES: isFeatureEnabled('PREREQUISITES'),
	PROJECT_SETTINGS: isFeatureEnabled('PROJECT_SETTINGS'),
	REIMBURSEMENT: isFeatureEnabled('REIMBURSEMENT'),
	UTILIZATION: isFeatureEnabled('UTILIZATION'),
	V2_ONBOARDING: isFeatureEnabled('V2_ONBOARDING'),
};
